"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpotifySocialLink1Schema = void 0;
exports.SpotifySocialLink1Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/spotify-sociallink/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "SpotifySocialLink1",
    "description": "Add a link to a Spotify artist",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:spotify-sociallink:1"
            ]
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "artistUri": {
                    "type": "string",
                    "description": "A spotify artist URI, e.g. spotify:artist:5lsC3H1vh9YSRQckyGv0Up",
                    "pattern": "^(spotify:artist:).*$"
                }
            },
            "required": [
                "artistUri"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy9zcG90aWZ5LXNvY2lhbGxpbmsvMS5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSx3QkFBd0IsR0FBRztJQUN0QyxLQUFLLEVBQUUsdUZBQXVGO0lBQzlGLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLG9CQUFvQjtJQUM3QixhQUFhLEVBQUUsZ0NBQWdDO0lBQy9DLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLHNCQUFzQixFQUFFLEtBQUs7SUFDN0IsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLCtDQUErQzthQUNoRDtTQUNGO1FBQ0QsWUFBWSxFQUFFO1lBQ1osTUFBTSxFQUFFLFFBQVE7WUFDaEIsc0JBQXNCLEVBQUUsS0FBSztZQUM3QixZQUFZLEVBQUU7Z0JBQ1osV0FBVyxFQUFFO29CQUNYLE1BQU0sRUFBRSxRQUFRO29CQUNoQixhQUFhLEVBQUUsa0VBQWtFO29CQUNqRixTQUFTLEVBQUUsdUJBQXVCO2lCQUNuQzthQUNGO1lBQ0QsVUFBVSxFQUFFO2dCQUNWLFdBQVc7YUFDWjtTQUNGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixZQUFZO1FBQ1osTUFBTTtLQUNQO0NBQ0YsQ0FBQSJ9